<template>
    <div class="login-form-home text-align-left">
        <div class="login-form-wrapper">
          <div class="bp-logo">
              <img src="@/assets/images/logos/BP.png" alt="bp logo">
              <p class="app-name">{{ $t('OUTER_PAGES.common.player')}}</p>
              <div class="logo-text">{{ $t('OUTER_PAGES.common.subheading')}}</div>
          </div>
          <form v-loading-form="loadingForm" class="form" name="loginForm" novalidate @submit.prevent="onResetPasswordFormSubmitted" v-if="!invalidResetLink">
              <div class="text-center loginForm loginForm-default">
                <div class="error-wrapper-table">
                  <div class="error-wrapper">
                      <div class="error" v-show="invalidResetLink">
                        <img src="@/assets/images/icons/error-icon.png" alt="error">
                        {{ $t('OUTER_PAGES.resetPassword.invalidLink')}}
                      </div>
                      <div class="error" v-show="(errors.has('confirmPassword') && formSubmitted)">
                        <img src="@/assets/images/icons/error-icon.png" alt="error">
                        {{ errors.first('confirmPassword') }}
                      </div>
                      <div class="error" v-show="(errors.has('password') && formSubmitted)">
                        <img src="@/assets/images/icons/error-icon.png" alt="error">
                        {{ errors.first('password') }}
                      </div>
                  </div>
                </div>
                <div class="form-group inputLogin">
                    <input
                      id="password"
                      type="password"
                      :class="{'error-input': (errors.has('password') && formSubmitted)}"
                      class="form-control"
                      :placeholder="$t('OUTER_PAGES.resetPassword.newPassword')"
                      v-model="password"
                      v-validate="'required|min:8|max:50'"
                      ref="password"
                      name="password">
                    <input
                      id="confirmPassword"
                      type="password"
                      :class="{'error-input': (errors.has('confirmPassword') && formSubmitted)}"
                      class="form-control"
                      :placeholder="$t('OUTER_PAGES.resetPassword.confirmPassword')"
                      v-model="confirmPassword"
                      v-validate="'confirmed:password'"
                      name="confirmPassword">
                </div>
              </div>
              <div class="text-center loginStructure">
                <button type="submit" class="btn buttonOnLogin btn-type-1">
                  <span class="button-content">
                    {{ $t('OUTER_PAGES.resetPassword.submit')}}
                  </span>
                </button>
              </div>
          </form>

          <div class="text-center loginForm forgotten-password loginForm-default">
            <div v-if="invalidResetLink && pageLoaded" class="text-align-left info-block">
              <span class="text-red">
                {{ $t('OUTER_PAGES.resetPassword.linkExpired')}}
              </span>
              <div class="text-align-left">
                <router-link class="login-link" :to="{ name: 'ForgottenPassword' }">{{ $t('OUTER_PAGES.resetPassword.requestNewLink')}}</router-link>
              </div>
            </div>
          </div>
        </div>
    </div>
</template>

<script>
import ApiService from '@/common/api.service'
import STATUS_CODES from '@/common/statusCodes'
import { TOASTER_SUCCESS } from '@/common/events.types'
import { CHECK_PASSWORD_RESET_TOKEN, RESET_PASSWORD_URL } from '@/constants/ApiConstants'

export default {
  name: 'ResetPassword',
  data () {
    return {
      confirmPassword: '',
      password: '',
      formSubmitted: false,
      invalidResetLink: false,
      pageLoaded: false,
      loadingForm: false
    }
  },
  computed: {
    resetPasswordToken: {
      get () {
        return this.$route.params.token
      }
    }
  },
  mounted () {
    ApiService.get(`${CHECK_PASSWORD_RESET_TOKEN.replace(':token', this.resetPasswordToken)}`)
      .then(response => {
        this.pageLoaded = true
        if (response.status.code === STATUS_CODES.BP_405) {
          this.invalidResetLink = true
        }
      })
      .catch(() => {
        this.pageLoaded = true
      })
  },
  methods: {
    onResetPasswordFormSubmitted () {
      this.$validator.validateAll().then(result => {
        if (!result) {
          this.formSubmitted = true
        } else {
          this.loadingForm = true

          ApiService.post(`${RESET_PASSWORD_URL.replace(':token', this.resetPasswordToken)}`, {
            password: this.password,
            confirmPassword: this.confirmPassword
          })
            .then(response => {
              this.$eventHub.$emit(TOASTER_SUCCESS, { message: this.$t('OUTER_PAGES.resetPassword.success') })
              this.$router.push({ name: 'Login' })
              this.loadingForm = false
            })
            .catch(({ status }) => {
              if (status.code === STATUS_CODES.BP_400) {
                this.invalidResetLink = true
              }
              this.loadingForm = false
            })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .login-link {
    font-size: 16px;
  }
</style>
